import { useContext } from 'react';

import { OmeMeetEntryInvitationsStateContext } from './OmeMeetEntryInvitationsContextProvider';

import OmeMeetEntryInvitationsData from './OmeMeetEntryInvitationsData';

const useOmeMeetEntryInvitationsData = () => {
  const [omeMeetEntryInvitationsState, setOmeMeetEntryInvitationsState] = useContext(OmeMeetEntryInvitationsStateContext);

  const getOmeMeetEntryInvitations = (omeMeetEntryId) => OmeMeetEntryInvitationsData.getOmeMeetEntryInvitationsData(omeMeetEntryId, omeMeetEntryInvitationsState, setOmeMeetEntryInvitationsState);
  const postOmeMeetEntryInvitations = (omeMeetEntryId, omeEntryInvitationArray) => OmeMeetEntryInvitationsData.postOmeMeetEntryInvitationsData(omeMeetEntryId, omeEntryInvitationArray, omeMeetEntryInvitationsState, setOmeMeetEntryInvitationsState);

  const clearOmeMeetEntryInvitationsArrayData = () => {
    setOmeMeetEntryInvitationsState({
      ...omeMeetEntryInvitationsState,
      isArrayLoading: false,
      isArrayLoaded: false,
      isSaving: false,
      isSaved: false,
      arrayData: [],
      message: ''
    });
  };

  const confirmSaveOmeMeetEntryInvitations = () => {
    setOmeMeetEntryInvitationsState({
      ...omeMeetEntryInvitationsState,
      isSaved: false
    });
  };

  const resetOmeMeetEntryInvitationsState = () => {
    setOmeMeetEntryInvitationsState(OmeMeetEntryInvitationsData.INITIAL_STATE);
  }

  return {
    omeMeetEntryInvitationsState,
    setOmeMeetEntryInvitationsState,
    getOmeMeetEntryInvitations,
    postOmeMeetEntryInvitations,
    clearOmeMeetEntryInvitationsArrayData,
    confirmSaveOmeMeetEntryInvitations,
    resetOmeMeetEntryInvitationsState
  };
};

export default useOmeMeetEntryInvitationsData;